// extracted by mini-css-extract-plugin
export default {"pageheading":"CaseStudies_pageheading__0Y5W9","row":"CaseStudies_row__pPBem","bgimg":"CaseStudies_bgimg__fjbRk"};